import type { ReactNode } from "react";
import { CalendarAppointmentsContextProvider } from "./CalendarAppointmentsContext";
import { BlockedIntervalsContextProvider } from "./BlockedIntervalsContext";
// import { CalendarGroupSessionsContextProvider } from "./CalendarGroupSessionsContext";
import { ScheduleContextProvider } from "../../../contexts/ScheduleContext";
import { CalendarTimeContextProvider } from "./CalendarTimeContext";
import { ShowCancelledSessionsContextProvider } from "./ShowCancelledSessionContext";
import { SessionTypesEditorContextProvider } from "./SessionTypesEditorContext";
import { SessionTypeEditorContextProvider } from "./session-type-editor-context/SessionTypeEditorContext";
import { PatientCreatorContextProvider } from "./patient-creator-context";
import { SavedTagContextProvider } from "./SavedTagContext";
import { ConfirmAttendanceModalContextProvider } from "./confirm-attendance-modal-context/ConfirmAttendanceModalContextProvider";
import { AppointmentSeriesModalContextProvider } from "./appointment-series-modal-context/AppointmentSeriesModalContext";
import { InvoicingModalContextProvider } from "./invoicing-modal-context";
import { CalendarNotificationsContextProvider } from "../components/layout/contexts/calendar-notifications-context";

type Props = { children: NonNullable<ReactNode> };

const OneOnOneSessionsPageContextProvider = ({ children }: Props) => (
  <CalendarTimeContextProvider>
    {/* data */}
    <ShowCancelledSessionsContextProvider>
      {/* <CalendarGroupSessionsContextProvider> */}
        <ScheduleContextProvider>
          <CalendarAppointmentsContextProvider>
            <BlockedIntervalsContextProvider>
              {/* modals */}
              <SessionTypesEditorContextProvider>
                <SessionTypeEditorContextProvider>
                  <PatientCreatorContextProvider>
                    <ConfirmAttendanceModalContextProvider>
                      <AppointmentSeriesModalContextProvider>
                        <InvoicingModalContextProvider>
                          <SavedTagContextProvider>
                            <CalendarNotificationsContextProvider>
                              {children}
                            </CalendarNotificationsContextProvider>
                          </SavedTagContextProvider>
                        </InvoicingModalContextProvider>
                      </AppointmentSeriesModalContextProvider>
                    </ConfirmAttendanceModalContextProvider>
                  </PatientCreatorContextProvider>
                </SessionTypeEditorContextProvider>
              </SessionTypesEditorContextProvider>
            </BlockedIntervalsContextProvider>
          </CalendarAppointmentsContextProvider>
        </ScheduleContextProvider>
      {/* </CalendarGroupSessionsContextProvider> */}
    </ShowCancelledSessionsContextProvider>
  </CalendarTimeContextProvider>
);

export default OneOnOneSessionsPageContextProvider;
